<template>
  <div class="text-center" fill-height fluid>
    <v-dialog scrollable v-model="dialog" width="950">
      <template v-slot:activator="{ on, attrs }"></template>

      <v-card>
        <v-card-text>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="d-none d-sm-flex">
              <v-img class="img-fluid" src="https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/modal-informasi.png"></v-img>
            </v-col>
            <v-col cols="12" sm="8" md="8" lg="8" xl="8">
              <div class="body-1 black--text">
                <p class="headline primary--text font-weight-bold py-2">
                  Mohon Maaf, Saat ini kami sedang melakukan pemutakhiran sistem!
                </p>
                <p>
                  Layanan saat ini ditutup sementara dalam rangka pemutakhiran sistem.
                </p>
                <!-- <p class="my-0 py-0 title">Hari&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;: <strong>Sabtu</strong></p>
                <p class="my-0 py-0 title">Tanggal&nbsp; &nbsp;: <strong>6 Maret 2021</strong></p>
                <p class="my-0 py-0 title">Pukul &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: <strong>17.30 WIB</strong></p> -->

                <br />
                <p class="my-0 py-0">Silakan muat ulang halaman ini secara berkala.</p>
                <p class="my-0 py-0">Kami akan menginformasikan kembali jika pemutakhiran sistem telah selesai.</p>
                <p class="mt-3">Mohon maaf atas ketidaknyamanan ini.</p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="body-1" class="ma-2" text @click="closeGuide">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const lc = window.localStorage;
const VIDEO = "VIDEO";
//@group Global Feature
export default {
  name: "home-info-maintenance",
  data() {
    return {
      dialog: false
    };
  },

  methods: {
    //@vuese
    //buka dialog
    open() {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    //@vuese
    //tutup dialog
    closeGuide() {
      lc.setItem(VIDEO, false);
      this.dialog = false;
      this.resolve();
    }
  }
};
</script>
